export function removeLastTwoChars(
  time?: string | null
): string | null | undefined {
  if (time && /\d{2}:\d{2}:\d{2}/.test(time)) {
    return time.slice(0, -3);
  }
  return time;
}
